













import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { CampaignModel } from '@/app/shared/models';
import DialogCampaignCreate from '@/app/shared/components/dialogs/campaign-create.vue';
import DataTableCampaign from '@/app/shared/components/data-tables/campaign-table.vue';
@Component({
  components: {
    DialogCampaignCreate,
    DataTableCampaign,
  },
})
export default class PanelCampaignComponent extends Vue {
  public campaigns: CampaignModel[] = [];
  private get refs() {
    return refsService;
  }

  created() {
    this.initialize();
  }

  public ConvertFrequencyType(
    value: string | null,
    type: string
  ): string | null {
    switch (type) {
      case 'Weekly':
        if (value) return this.refs.enums.Week[parseInt(value)];
        return null;

      case 'Monthly':
        if (value) return this.refs.enums.Month[parseInt(value)];
        return null;
      default:
        return null;
    }
  }

  private async initialize() {
    try {
      this.campaigns = [];
      const res = await this.refs.modules.campaign.getCampaignByContractId(
        this.refs.modules.contract.contract.Id
      );
      if (!res) {
        return;
      }

      this.refs.modules.loading.SET_REQUEST(true);
      this.campaigns = Array.from(
        res.reduce((current: CampaignModel[], next: CampaignModel) => {
          let campaignId = '';
          if (next.CampaignId != undefined)
            campaignId = next.CampaignId?.toString();
          if (!current.find((r) => r && r.Id === next.Id)) {
            if (!next.NotifyQuery) {
              next.NotifyQuery = [];
            }
            next.NotifyQuery.push(campaignId);
            current.push(next);
          } else {
            current
              ?.find((r) => r && r.Id === next.Id)
              ?.NotifyQuery?.push(campaignId);
          }
          return current;
        }, [])
      );

      this.campaigns.forEach((campaign) => {
        campaign.StartDateCustom = this.$d(
          new Date(campaign.StartDate),
          'short'
        );
      });
      this.refs.modules.loading.SET_REQUEST(false);
    } catch (err) {
      this.refs.modules.loading.SET_REQUEST(false);
      throw new Error(err);
    }
  }
}
